(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class KsTestimonialsSlider extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      if (window.Swiper) {
        this.initSwiper()
        return
      }

      let script = document.querySelector('#swiper-script')
      if (! script) {
        script = document.createElement('script')
        script.id = 'swiper-script'
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'
        script.onload = () => this.initSwiper()
        document.head.appendChild(script)
      } else { // Script exists, wait for it to load
        if (window.Swiper) {
          this.initSwiper()
        } else {
          script.addEventListener('load', () => this.initSwiper())
        }
      }
    }

    initSwiper() {
      const swiperEl = this.querySelector('.swiper');
      if (! swiperEl) return;
      


      this.slider = new Swiper(swiperEl, {
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        threshold: 10,
        speed: Number(this.dataset.sliderSpeed) || 300,
        spaceBetween: -18,
        breakpoints: {
          0: {
            slidesPerView: 1.2
          },
          576: {
            slidesPerView: 1.5
          },
          768: {
            slidesPerView: 2.4
          },
          992: {
            slidesPerView: 2.6
          },
          1200: {
            slidesPerView: 3.4
          }
        },
        navigation: {
          enabled: true,
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? {
            delay: Number(this.dataset.sliderAutoplay) * 1000
          }
          : false
      });
    }
  }
  customElements.define('testimonials-slider', KsTestimonialsSlider)

  } catch(e) { console.error(e); }
})();
})();
